<template>
  <v-row class="pa-5">
    <v-col>
      <v-checkbox v-model="DaycareSixHours" label="Six Hours"></v-checkbox>
      <v-checkbox v-model="DaycareTwelveHours" label="Twelve Hours"></v-checkbox>
    </v-col>
    <v-col>
      <v-select
        v-model="DaycareNumberOfFurkids"
        :items="['None','1 kid', '2 kids', '3 or more']"
        label="Number of Furkids"
      ></v-select>
    </v-col>
  </v-row>
</template>

<script>
export default {
  data() {
    return {
      DaycareSixHours: false,
      DaycareTwelveHours: false,
      DaycareNumberOfFurkids: false
    };
  },
  watch: {
    DaycareSixHours: function(val) {
      this.$emit("change", "DaycareSixHours", val);
    },
    DaycareTwelveHours: function(val) {
      this.$emit("change", "DaycareTwelveHours", val);
    },
    DaycareNumberOfFurkids: function(val) {
      this.$emit("change", "DaycareNumberOfFurkids", val);
    }
  }
};
</script>